import {
	type Artifact,
	type Figure,
	type GeoMap,
	type GoReactExternalTool,
	type PageProgress,
	type Poll,
	type PollChoice,
	type VoiceRecording,
	type AiChatbox,
	type Chart,
	type Carousel
} from '@editor2/types/pageElements';
import { pick } from './pick';

export const figureToFigureProperties = (element: Figure) =>
	pick(element, [
		'family_id',
		'figure_type',
		'figure_subtype',
		'figure_position',
		'figure_number',
		'title',
		'payload',
		'payload_metadata',
		'description',
		'caption',
		'credits',
		'transcript_url',
		'instructions',
		'citation',
		'map_json_data',
		'figure_backup_url',
		'header_style',
		'quote_author',
		'quote_citation',
		'quote_text',
		'disable_expanded_view'
	]);

export const geoMapToGeoMapProperties = (element: GeoMap) =>
	pick(element, [
		'family_id',
		'geomap_type',
		'figure_number',
		'title',
		'data',
		'labels',
		'colors',
		'tooltip',
		'margins',
		'scale',
		'translate',
		'description',
		'caption',
		'credits',
		'instructions'
	]);

export const pageProgressToPageProgressProperties = (element: PageProgress) =>
	pick(element, [
		'target_page_family_id',
		'min_time_spent_estimation_threshold',
		'active_prediction_text',
		'passive_prediction_text',
		'active_prediction_bottom_text'
	]);

export const voiceRecordingToVoiceRecordingProperties = (element: VoiceRecording) =>
	pick(element, [
		'autosubmit',
		'phone',
		'instructions',
		'column_name',
		'filename_template',
		'lms_name',
		'autosubmit_button_label'
	]);

export const artifactToArtifactProperties = (element: Artifact) =>
	pick(element, [
		'type',
		'title',
		'artifact_url',
		'embed_code',
		'transcript_url',
		'credits',
		'citation',
		'artifact_backup_url'
	]);

export const chartToChartProperties = (element: Chart) =>
	pick(element, [
		'family_id',
		'metadata',

		'figure_number',
		'title',
		'caption',
		'description',
		'credit',
		'data',
		'chart_type',
		'orientation',
		'series_orientation',
		'colors',
		'min_bound',
		'max_bound',
		'axis_type',
		'margins',
		'show_labels',
		'show_markers',
		'allow_zoom',

		'x_axis_type',
		'date_format',
		'fill_line',
		'x_ticks',
		'x_axis_label',
		'y_axis_label',
		'line_stroke_width',

		'type',
		'labels_width',
		'round_to'
	]);

export const pollToPollProperties = (element: Poll) =>
	pick(element, ['family_id', 'body', 'instructions', 'caption', 'description', 'credits']);

export const pollChoiceToPollChoicePropeties = (element: PollChoice) =>
	pick(element, ['body', 'shortened_body']);

export const goReactToGoReactProperties = (element: GoReactExternalTool) =>
	pick(element, [
		'type',
		'config',
		'score_config',
		'prompt_body',
		'title',
		'caption',
		'credits',
		'transcript_url'
	]);

export const carouselToCarouselProperties = (element: Carousel) =>
	pick(element, [
		'family_id',
		'caption',
		'credits',
		'title',
		'figure_number',
		'theme',
		'color',
		'logo_url',
		'logo_alt',
		'slides'
	]);

export const aiChatboxToAiChatboxProperties = (element: AiChatbox) =>
	pick(element, ['title', 'config']);
